import Schema from "AppReact/schema";

export default {
  fileName: Schema('string', 'primitive', { defaultValue: '' }),
  contentType: Schema('string', 'primitive', { defaultValue: '' }),
};
